import { Component, input } from '@angular/core';

import { WebsitePage } from '../../model/website-page';

/** The `website-page` template: an editorial page with an optional photo and headed paragraphs. */
@Component({
  selector: 'website-page',
  host: {
    style: 'display: contents'
  },
  template: `
    <!-- Title Page -->
    <section class="bg-title-page p-t-15 p-b-16 flex-col-c-m">
      <h2 class="l-text2 t-center">
        {{page().name}}
      </h2>
      @if (page().subname) {
        <p class="m-text13 t-center">
          {{page().subname}}
        </p>
      }
    </section>

    <!-- content page -->
    <section class="bgwhite p-t-66 p-b-38">
      <div class="container">
        <div class="row">
          @if (page().photo; as photo) {
            <div class="col-md-4 p-b-30">
              <div class="hov-img-zoom">
                <img [src]="photo" [alt]="page().name">
              </div>
            </div>
          }

          <div [class]="(page().photo ? 'col-md-8' : 'col-md') + ' p-b-30'">
            @for (paragraph of page().paragraphs; track $index) {
              @if (paragraph.heading) {
                <h3 class="m-text26 p-t-15 p-b-16">
                  {{paragraph.heading}}
                </h3>
              }
              <p class="p-b-28" [innerHTML]="paragraph.text"></p>
            }
          </div>
        </div>
      </div>
    </section>
    `
})
export class WebsitePageComponent {

  readonly page = input.required<WebsitePage>();

}
